import { render, staticRenderFns } from "./FooterEsc.vue?vue&type=template&id=0f774406&scoped=true&"
import script from "./FooterEsc.vue?vue&type=script&lang=js&"
export * from "./FooterEsc.vue?vue&type=script&lang=js&"
import style0 from "./FooterEsc.vue?vue&type=style&index=0&id=0f774406&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f774406",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VFooter,VIcon,VImg})
